export default "__VITE_ASSET__DL45NVwp__"